// assets
import { HowToVote } from "@mui/icons-material";
import { RoleLevel } from "../../../../../../../domain/entities/Role";

// ==============================|| CHOICE MENU ITEMS ||============================== //
// School Choice data imported from the Choice system. Shown only when the org's Choice
// data import is On (Site Configurations, Choice Dashboard); further Choice pages go here.

const choice = {
  id: "choice",
  title: "Choice",
  caption: "School choice lottery data",
  type: "group",
  level: RoleLevel.SignatureRequestor,
  hidden: (siteConfigs) => siteConfigs?.enableChoiceDataImport !== "On",
  children: [
    {
      id: "choiceDashboard",
      title: "Dashboard",
      type: "item",
      icon: HowToVote,
      color: "#6A1B9A",
      url: "/choiceDashboard",
      breadcrumbs: false,
    },
  ],
};

export default choice;
